import styled from 'styled-components';
import { Deck, Card } from '@movember/mo-gel';
import { getRGBOpacity, normaliseColor } from '@movember/mo-gel/utils/colors';
import { Heading, Text } from '@movember/mo-gel';
import { ReactComponent as BackChevron } from '../../images/icons/icon_chevron_right.svg';

export const StyledLowLevelGroupWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: scroll;
  height: 100%;
  width: 100%;
  position: relative;
  background: white;
  justify-content: center;
  margin: 0;
`;

export const StyledHeadingWrapper = styled.div`
  background-color: ${(props) => getRGBOpacity(props.theme.colors.brandThemeLight100, 0.5)};
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5rem 1rem;
  text-align: left;
  align-items: flex-start;
  box-sizing: border-box;
  color: ${(props) => {
    return normaliseColor(props.theme.typography.defaultColors, props.theme) || props.theme.colors.primaryFont;
  }};

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    padding: 1.1rem 1.75rem 7rem 1.75rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1.1rem 6.75rem 7rem 6.75rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 1.1rem 14.9rem 7rem 14.9rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.xl}) {
    padding: 1.1rem 18rem 7rem 18rem;
  }
`;

export const StyledHeadingAndLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.brandThemeLight500};
  margin-bottom: 1.1rem;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
`;

export const StyledHeading = styled(Heading)`
  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    margin-bottom: 0;
    width: 500px;
  }
`;

export const StyledChevron = styled(BackChevron)`
  transform: rotateY(180deg);
`;

export const StyledEditLinkText = styled(Text)`
  background-repeat: repeat-x;
  background-image: linear-gradient(
    to right,
    ${(props) => props.theme.colors.actionPrimary300},
    ${(props) => props.theme.colors.actionPrimary300}
  );
  background-size: 1px 0.112em;
  background-position: 0 1.05em;
  background-position: left 0 bottom 1px;
`;

export const StyledLinkWrapper = styled.div`
  display: flex;
  width: 9.5rem;
  justify-content: space-between;

  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.actionPrimary300};

    svg {
      path:nth-of-type(1) {
        fill: ${(props) => props.theme.colors.actionPrimary300};
      }
    }
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.xs}) {
    width: 9rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    width: auto;
  }
`;

export const StyledHeadingTextWrapper = styled.div`
  width: 90%;
  margin-bottom: 0;
  color: ${(props) => {
    return normaliseColor(props.theme.typography.defaultColors, props.theme) || props.theme.colors.primaryFont;
  }};

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    margin-right: 1.5rem;
    margin-bottom: unset;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    width: 80%;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    width: 95%;
  }
`;

export const StyledLowLevelInsightsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem 3rem 1rem;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    padding-left: 5rem;
    padding-right: 5rem;
  }
`;

export const StyledAdditionalsContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 20rem;
  margin: 1rem auto;
`;

export const StyledOutcomeGroupWrapper = styled(Deck)`
  margin: -3rem auto 2rem auto;
  max-width: 1116px;
  z-index: 1;
  display: block;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledOutcomeContainer = styled(Card)`
  padding: 2rem;
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 3rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 4rem;
  }
`;
